<div class="raw-response-modal">
	<div class="modal-header">
		<h2 class="modal-title">
			<ng-container *ngIf="data.context === 'inventory'">
				<span class="title-label">Inventory sync</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'sku_push'">
				<span class="title-label">Push SKU</span>
				<span *ngIf="data.stockid" class="title-order">{{ data.stockid }}</span>
				<span *ngIf="!data.stockid" class="title-order">Push in-scope SKUs</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'inbound'">
				<span class="title-label">Inbound order</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">success</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'open_orders'">
				<span class="title-label">Open B2B orders</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'shipments'">
				<span class="title-label">Shipments poll</span>
			</ng-container>
			<ng-container *ngIf="data.context === 'cancel'">
				<span class="title-label">Cancel at 3PL</span>
				<span class="title-order">Order {{ data.orderno }}</span>
				<span *ngIf="data.content?.success === true" class="badge-exported">cancelled</span>
				<span *ngIf="data.content?.success === false" class="badge-failed">failed</span>
			</ng-container>
			<ng-container *ngIf="data.context !== 'inventory' && data.context !== 'sku_push' && data.context !== 'inbound' && data.context !== 'open_orders' && data.context !== 'shipments' && data.context !== 'cancel'">
				<span class="title-label">Raw export</span>
				<span class="title-order">Order {{ data.orderno }}</span>
				<span *ngIf="data.export_status === 'failed'" class="badge-failed">failed</span>
				<span *ngIf="data.export_status === 'exported'" class="badge-exported">exported</span>
			</ng-container>
		</h2>
		<div class="modal-actions cancel-actions" *ngIf="data.context === 'cancel' && data.orderno">
			<mat-checkbox [(ngModel)]="cancelWarehouseOnly" [disabled]="sending || data.content?.success === true"
				matTooltip="Use when the sales order is already cancelled in the ERP: sends warehouse cancellation only and does not complete lines or clear picking.">
				Warehouse only — ERP already cancelled
			</mat-checkbox>
		</div>
		<div class="modal-actions">
		<button *ngIf="data.context === 'cancel' && data.orderno" mat-raised-button color="warn" (click)="sendCancel()" [disabled]="sending || data.content?.success === true" matTooltip="Send cancellation to PGS — only works while order is still open (not picked/shipped)">
			<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
			<mat-icon *ngIf="!sending">cancel</mat-icon>
			<span class="send-label">{{ sending ? 'Cancelling…' : (isPreviewMode ? 'Send cancel' : 'Send again') }}</span>
		</button>
		<button
			*ngIf="data.show_pre_export_reauth && data.orderno && !data.context"
			mat-stroked-button
			color="accent"
			type="button"
			(click)="reauthorizePreExport()"
			[disabled]="preExportReauthWorking || sending"
			matTooltip="New gateway hold for the full open order amount (use if the hold expired or no longer matches the order)">
			<mat-spinner *ngIf="preExportReauthWorking" diameter="20"></mat-spinner>
			<mat-icon *ngIf="!preExportReauthWorking">credit_card</mat-icon>
			<span class="send-label">{{ preExportReauthWorking ? 'Authorizing…' : 'Re-authorize card' }}</span>
		</button>
		<button *ngIf="data.orderno && data.context !== 'cancel'" mat-raised-button color="primary" (click)="sendExport()" [disabled]="sending" matTooltip="Send order to 3PL">
			<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
			<mat-icon *ngIf="!sending">send</mat-icon>
			<span class="send-label">{{ sending ? 'Sending…' : (isPreviewMode ? 'Send' : 'Send again') }}</span>
		</button>
			<mat-checkbox *ngIf="data.context === 'inventory'" [(ngModel)]="inventorySyncNewSkusOnly" class="inventory-new-skus-checkbox mr-2" matTooltip="PGS still returns the full catalog; only SKU+warehouse rows not already cached are applied (no stale cleanup). Use after full sync when adding new items.">
				New SKUs only
			</mat-checkbox>
			<button *ngIf="data.context === 'inventory'" mat-raised-button color="primary" (click)="sendInventorySync()" [disabled]="sending" matTooltip="Send inventory sync request to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : 'Send' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && data.stockid" mat-raised-button color="primary" (click)="sendSkuPush()" [disabled]="sending" matTooltip="Push this SKU to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : 'Send' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-stroked-button (click)="loadSkuPushList()" [disabled]="skuPushListLoading" matTooltip="Load up to 5000 SKUs from the server. Set “Skip first” below to resume after earlier batches (same stockid order as the server).">
				<mat-spinner *ngIf="skuPushListLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!skuPushListLoading">refresh</mat-icon>
				<span class="send-label">{{ skuPushListLoading ? 'Loading…' : 'Load list' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-raised-button color="primary" (click)="sendBatchSkuPush()" [disabled]="!canSendBatch()" matTooltip="Send pending SKUs in batches of 50; continues automatically until all are sent">
				<mat-spinner *ngIf="skuPushBatchSending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!skuPushBatchSending">send</mat-icon>
				<span class="send-label">{{ skuPushBatchSending ? 'Sending…' : 'Send batch (50)' }}</span>
			</button>
			<button *ngIf="data.context === 'sku_push' && !data.stockid" mat-stroked-button (click)="exportAllSkuPushResults()" matTooltip="Export all results as JSON">
				<mat-icon>file_download</mat-icon>
				<span class="send-label">Export all</span>
			</button>
			<button *ngIf="data.context === 'inbound'" mat-raised-button color="primary" (click)="sendInbound()" [disabled]="sending" matTooltip="Send inbound order to 3PL">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">send</mat-icon>
				<span class="send-label">{{ sending ? 'Sending…' : (isPreviewMode ? 'Send' : 'Send again') }}</span>
			</button>
			<button *ngIf="data.context === 'shipments'" mat-raised-button color="primary" (click)="sendShipmentsPoll()" [disabled]="sending" matTooltip="Send shipment poll request and refresh response">
				<mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!sending">sync</mat-icon>
				<span class="send-label">{{ sending ? 'Polling…' : 'Poll again' }}</span>
			</button>
			<button *ngIf="requestPayloadJson" mat-icon-button (click)="copyToClipboard()" [matTooltip]="copied ? 'Copied!' : 'Copy all'" [class.copied]="copied">
				<mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
			</button>
			<button mat-icon-button (click)="close()" matTooltip="Close">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
	<div class="modal-body">
		<section class="payload-section export-preview-payment" *ngIf="showExportPaymentPreview">
			<div class="section-header d-flex flex-wrap align-items-center justify-content-between gap-2">
				<h3 class="section-title mb-0">Card &amp; pre-authorization (export)</h3>
				<button
					mat-stroked-button
					color="primary"
					type="button"
					(click)="openAttachSavedCardForExportPreview()"
					matTooltip="Pick a saved card, attach it to the order, then place a hold for the open order total (same as export queue)">
					<mat-icon>credit_card</mat-icon>
					<span class="send-label">Attach saved card</span>
				</button>
			</div>
			<div class="epp-card" [ngClass]="exportPreviewPreauthBlocked ? 'epp-card--warn' : 'epp-card--ok'">
				<div class="epp-row" *ngIf="exportPreviewOpenTotal != null">
					<span>Open remainder (uninvoiced)</span>
					<strong>{{ exportPreviewOpenTotal | currency }}</strong>
				</div>
				<div class="epp-row" *ngIf="exportPreauth?.preauth_checked">
					<span>PreAuth hold on file</span>
					<strong>{{ (exportPreauth?.preauth_total ?? 0) | currency }}</strong>
				</div>
				<div class="epp-row epp-row--muted" *ngIf="exportPreauth && exportPreviewOpenTotal != null && !exportPreauth.preauth_checked">
					<span>PreAuth (config)</span>
					<span>Not evaluated — PreAuth disabled or no hold workflow for this order</span>
				</div>
				<div class="epp-row epp-row--muted" *ngIf="exportPreauth?.preauth_hold_unavailable">
					<span>PreAuth payload</span>
					<span class="text-warning">Hold details unavailable (unexpected if PreAuth is on)</span>
				</div>
				<p class="epp-msg mb-1" *ngIf="exportPreauth?.blocked && exportPreauth?.message">{{ exportPreauth.message }}</p>
				<div class="epp-row" *ngIf="exportCcPaymentGate && (exportCcPaymentGate.open_order_total != null || exportCcPaymentGate.blocked)">
					<span>CC / prepay terms — active auth total</span>
					<strong>{{ (exportCcPaymentGate.auth_held_total ?? 0) | currency }}</strong>
				</div>
				<p class="epp-msg mb-0" *ngIf="exportCcPaymentGate?.blocked && exportCcPaymentGate?.message">{{ exportCcPaymentGate.message }}</p>
			</div>
		</section>
		<section class="payload-section export-line-breakdown" *ngIf="exportLineBreakdown?.lines?.length">
			<div class="section-header">
				<h3 class="section-title">ERP lines → 3PL export</h3>
			</div>
			<p class="small text-muted mb-2">
				Included: <strong class="text-success">{{ exportLineBreakdown.included_line_count }}</strong> ·
				Skipped: <strong class="tpl3pl-skip-count">{{ exportLineBreakdown.excluded_line_count }}</strong>
				<span class="d-block mt-1"><strong>Skipped</strong> rows are shaded (orange stripe). Anything with <strong>reduce stock</strong> turned off in <code>product_types</code> is not sent (plus promo SKUs). Order lines only have a SKU — that flag comes from the item master lookup.</span>
				<span *ngIf="!requestPayloadJson" class="d-block mt-1">PGS request JSON is only shown when integration type is PGS; this table always reflects the same rules as the outbound payload.</span>
			</p>
			<table mat-table [dataSource]="exportLineBreakdown.lines" class="w-100 compact-table mb-2 tpl3pl-export-lines-table">
				<ng-container matColumnDef="lineno">
					<th mat-header-cell *matHeaderCellDef>Line</th>
					<td mat-cell *matCellDef="let row">{{ row.orderlineno ?? '—' }}</td>
				</ng-container>
				<ng-container matColumnDef="parent">
					<th mat-header-cell *matHeaderCellDef>Parent</th>
					<td mat-cell *matCellDef="let row">{{ row.parentlineno ?? '—' }}</td>
				</ng-container>
				<ng-container matColumnDef="sku">
					<th mat-header-cell *matHeaderCellDef>SKU</th>
					<td mat-cell *matCellDef="let row" class="text-monospace">{{ row.stkcode }}</td>
				</ng-container>
				<ng-container matColumnDef="qty">
					<th mat-header-cell *matHeaderCellDef>Qty</th>
					<td mat-cell *matCellDef="let row">{{ row.quantity ?? '—' }}</td>
				</ng-container>
				<ng-container matColumnDef="flag">
					<th mat-header-cell *matHeaderCellDef>Type (item master)</th>
					<td mat-cell *matCellDef="let row" class="tpl3pl-type-cell">
						<ng-container *ngIf="row.product_type_description">{{ row.product_type_description }}</ng-container>
						<ng-container *ngIf="!row.product_type_description && row.product_type_label">{{ row.product_type_label }}</ng-container>
						<span *ngIf="!row.product_type_description && !row.product_type_label" class="text-muted">—</span>
						<div class="small text-muted tpl3pl-pt-desc mt-1" *ngIf="row.has_product_types_row === false && row.stockmaster_type_code">
							Type code on item master <code>{{ row.stockmaster_type_code }}</code> — <strong>no</strong> matching <code>product_types</code> row; defaults were used for rules.
						</div>
						<div class="small text-muted tpl3pl-pt-desc" *ngIf="row.product_type_description && row.product_type_label">
							Label {{ row.product_type_label }}
						</div>
					</td>
				</ng-container>
				<ng-container matColumnDef="send">
					<th mat-header-cell *matHeaderCellDef>3PL</th>
					<td mat-cell *matCellDef="let row">
						<span *ngIf="row.included" class="badge badge-success tpl3pl-badge-include">Include</span>
						<span *ngIf="!row.included" class="badge tpl3pl-badge-skip" matTooltip="This line is not in the outbound 3PL payload">Skip</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="reason">
					<th mat-header-cell *matHeaderCellDef>Reason</th>
					<td mat-cell *matCellDef="let row">
						<span *ngIf="row.included && row.warning" class="text-warning small">{{ row.warning }}</span>
						<ng-container *ngIf="!row.included">
							<span>{{ excludeReasonLabel(row.exclude_reason) }}</span>
							<span class="d-block small text-muted mt-1" *ngIf="row.product_type_description && row.exclude_reason !== 'promo_sku'">{{ row.product_type_description }}</span>
						</ng-container>
						<span *ngIf="row.included && !row.warning">—</span>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="['lineno', 'parent', 'sku', 'qty', 'flag', 'send', 'reason']"></tr>
				<tr
					mat-row
					*matRowDef="let r; columns: ['lineno', 'parent', 'sku', 'qty', 'flag', 'send', 'reason']"
					[class.tpl3pl-export-row--skipped]="!r.included"
					[class.tpl3pl-export-row--included]="r.included"
					[attr.aria-label]="r.included ? 'Line included in 3PL export' : 'Line skipped — not sent to 3PL'"></tr>
			</table>
		</section>
		<section class="payload-section" *ngIf="!(data.context === 'sku_push' && !data.stockid)">
			<div class="section-header">
				<h3 class="section-title">{{ data.context === 'inbound' ? 'Inbound payload' : (data.context === 'shipments' ? 'Data being sent (request)' : (data.context === 'open_orders' ? 'Request' : (data.context === 'cancel' ? 'Cancel request' : 'Payload we sent'))) }}</h3>
				<button *ngIf="requestPayloadJson" mat-icon-button (click)="copyRequest()" [matTooltip]="copiedRequest ? 'Copied!' : 'Copy'" [class.copied]="copiedRequest">
					<mat-icon>{{ copiedRequest ? 'check' : 'content_copy' }}</mat-icon>
				</button>
			</div>
			<div *ngIf="showOutboundPickLineSummary" class="tpl3pl-outbound-pick-summary mb-2">
				<div class="alert alert-success small mb-2" *ngIf="outboundPickLineSkus.length > 0">
					<strong>Pick lines only — these SKUs are what 3PL receives as order lines</strong>
					<div class="tpl3pl-sku-chips mt-2">
						<span class="badge tpl3pl-sku-chip" *ngFor="let s of outboundPickLineSkus">{{ s }}</span>
					</div>
					<p class="mb-0 mt-2">
						Anything <strong>skipped</strong> in the table above (per <code>product_types</code>, promo SKUs, etc.) is <strong>not</strong> in this list and is <strong>not</strong> sent as a line.
						The JSON may still contain <code>comment</code> / <code>notes</code> — that is order-level text, not extra pick lines.
					</p>
				</div>
				<div class="alert alert-warning small mb-0" *ngIf="exportLineBreakdown && outboundPayloadVsBreakdownMismatch">
					<strong>Unexpected mismatch</strong> between the table (included rows) and line items in the JSON. The lists above should match; if they do not, something is wrong.
				</div>
			</div>
			<pre *ngIf="requestPayloadJson" class="response-pre">{{ requestPayloadJson }}</pre>
			<p *ngIf="!requestPayloadJson" class="payload-missing">{{ data.context === 'inventory' ? 'Request payload was not stored for this sync.' : (data.context === 'sku_push' ? 'Send to see the payload and response.' : (data.context === 'inbound' ? 'No inbound payload.' : (data.context === 'cancel' ? 'Click "Send cancel" to send DELETE to PGS and see the response.' : 'Request payload was not stored for this export. Re-export the order to see the payload we send.'))) }}</p>
		</section>
		<p *ngIf="data.context === 'sku_push' && !data.stockid && skuPushRows.length > 0" class="small text-muted mb-2">
			{{ skuPushRows.length }} in table
			<span *ngIf="skuPushLoadedRangeLabel"> — positions {{ skuPushLoadedRangeLabel }}</span>
			<span *ngIf="skuPushListTotal == null"> (total unknown)</span>
			— {{ skuPushPendingCount }} pending, {{ skuPushSucceededCount }} ok, {{ skuPushFailedCount }} failed
		</p>
		<section class="payload-section" *ngIf="data.context === 'sku_push' && !data.stockid">
			<div class="section-header d-flex justify-content-between align-items-center flex-wrap">
				<h3 class="section-title mb-0">SKU list</h3>
				<div class="d-flex align-items-center flex-wrap gap-2">
					<mat-form-field appearance="outline" class="sku-push-offset-field">
						<mat-label>Skip first (offset)</mat-label>
						<input matInput type="number" min="0" step="1" [(ngModel)]="skuPushLoadOffsetInput" matTooltip="0 = start at first SKU. After sending 1000, use 1000 then Load list (or use Load more). Order matches server: stockid A→Z within your product filters.">
						<mat-hint align="end">Resume here</mat-hint>
					</mat-form-field>
					<mat-form-field appearance="outline" class="sku-push-search">
						<mat-label>Search SKU</mat-label>
						<input matInput [(ngModel)]="skuPushSearch" placeholder="Type to search server (no Load list needed)">
						<button mat-icon-button matSuffix (click)="skuPushSearch = ''" *ngIf="skuPushSearch" matTooltip="Clear">
							<mat-icon>close</mat-icon>
						</button>
					</mat-form-field>
					<button *ngIf="skuPushCanLoadMore" mat-stroked-button (click)="loadMoreSkuPushList()" [disabled]="skuPushListLoading">Load more</button>
				</div>
			</div>
			<table mat-table [dataSource]="skuPushRowsPaged" class="w-100 compact-table mb-2">
				<ng-container matColumnDef="stockid">
					<th mat-header-cell *matHeaderCellDef>SKU</th>
					<td mat-cell *matCellDef="let row">{{ row.stockid }}</td>
				</ng-container>
				<ng-container matColumnDef="payload">
					<th mat-header-cell *matHeaderCellDef>Payload</th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button (click)="viewPayload(row)" matTooltip="View request payload for this SKU">
							<mat-icon>description</mat-icon>
						</button>
					</td>
				</ng-container>
				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef>Status</th>
					<td mat-cell *matCellDef="let row">
						<span *ngIf="row.status === 'pending'" class="badge badge-secondary">Pending</span>
						<span *ngIf="row.status === 'sending'" class="badge badge-warning">Sending…</span>
						<span *ngIf="row.status === 'success'" class="badge badge-success">Success</span>
						<span *ngIf="row.status === 'failed'" class="badge badge-danger">Failed</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="message">
					<th mat-header-cell *matHeaderCellDef>Message</th>
					<td mat-cell *matCellDef="let row" class="message-cell">{{ row.message || '–' }}</td>
				</ng-container>
				<ng-container matColumnDef="send">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button color="primary" (click)="sendOneRow(row)" [disabled]="row.status !== 'pending'" matTooltip="Send this SKU">
							<mat-icon>send</mat-icon>
						</button>
					</td>
				</ng-container>
				<ng-container matColumnDef="view_raw">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<button mat-icon-button color="accent" (click)="openRawForSkuRow(row)" [disabled]="row.fullResult == null" matTooltip="View raw response">
							<mat-icon>code</mat-icon>
						</button>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="['stockid', 'payload', 'status', 'message', 'send', 'view_raw']"></tr>
				<tr mat-row *matRowDef="let r; columns: ['stockid', 'payload', 'status', 'message', 'send', 'view_raw'];"></tr>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell text-center text-muted py-3" colspan="6">{{ skuPushListLoading ? 'Loading…' : (skuPushSearch ? 'No SKUs match the search.' : 'Click Load list to fetch in-scope SKUs.') }}</td>
				</tr>
			</table>
			<mat-paginator
				*ngIf="skuPushRowsFiltered.length > 0"
				[length]="skuPushRowsFiltered.length"
				[pageSize]="skuPushPageSize"
				[pageIndex]="skuPushPageIndex"
				[pageSizeOptions]="[10, 25, 50, 100]"
				(page)="onSkuPushPage($event)"
				showFirstLastButtons
				aria-label="SKU list page">
			</mat-paginator>
		</section>
		<section class="payload-section" *ngIf="!(data.context === 'sku_push' && !data.stockid)">
			<div class="section-header">
				<h3 class="section-title">{{ data.context === 'sku_push' && data.stockid ? '3PL raw response' : 'Response we received' }}</h3>
				<button *ngIf="!isPreviewMode && responseJson" mat-icon-button (click)="copyResponse()" [matTooltip]="copiedResponse ? 'Copied!' : 'Copy'" [class.copied]="copiedResponse">
					<mat-icon>{{ copiedResponse ? 'check' : 'content_copy' }}</mat-icon>
				</button>
			</div>
			<p *ngIf="isPreviewMode" class="payload-missing">Not sent yet. Use the Send button above to send the request and see the response.</p>
			<p *ngIf="!isPreviewMode && circuitOpen" class="small text-muted mb-1">No request was sent to the 3PL (circuit breaker open). Below is the actual response from our system.</p>
			<pre *ngIf="!isPreviewMode && responseJson" class="response-pre">{{ responseJson }}</pre>
		</section>
	</div>
</div>
